import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, DateTimeInput } from '@weezevent/nacre';

import css from '../emaillogs.module.css';
import { removeTimezoneOfDate, setTimezoneToDate } from '../../../../utils/utils';

export const DateTimeFilterModal = ({ open, onClose, onSubmit, dateAfter, dateBefore }) => {
    const { t } = useTranslation();
    const [afterValue, setAfterValue] = React.useState(dateAfter ? setTimezoneToDate(dateAfter) : null);
    const [beforeValue, setBeforeValue] = React.useState(dateBefore ? setTimezoneToDate(dateBefore) : null);
    const [activeKey, setActiveKey] = React.useState('last-week');
    const now = setTimezoneToDate(new Date());

    const presets = React.useMemo(() => {
        const startOfToday = setTimezoneToDate(new Date(now).setHours(0, 0, 0, 0));

        const endOfToday = setTimezoneToDate(new Date(now).setHours(23, 59, 59, 999));

        const lastWeekStart = new Date(now);
        lastWeekStart.setDate(lastWeekStart.getDate() - 7);

        const lastMonthStart = new Date(now);
        lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);

        const lastYearStart = new Date(now);
        lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

        return [
            { key: 'custom', label: t('sauron.emails.email-logs.date-filter.custom'), date_after: null, date_before: null },
            { key: 'today', label: t('sauron.emails.email-logs.date-filter.today'), date_after: startOfToday, date_before: endOfToday },
            { key: 'last-week', label: t('sauron.emails.email-logs.date-filter.last-week'), date_before: now, date_after: lastWeekStart },
            { key: 'last-month', label: t('sauron.emails.email-logs.date-filter.last-month'), date_before: now, date_after: lastMonthStart },
            { key: 'last-year', label: t('sauron.emails.email-logs.date-filter.last-year'), date_before: now, date_after: lastYearStart }
        ];
    }, []);

    return (
        <Modal
            className={css['modal-container card-subtitle']}
            size={'large'}
            open={open}
            allowExternalClosing={true}
            onClose={onClose}
            title={t('sauron.emails.email-logs.date-filter.title')}
            subtitle={t('sauron.emails.email-logs.date-filter.subtitle')}
            customFooter={
                <Button.Group>
                    <Button onClick={onClose} label={t('common.cta.cancel')} />
                    <Button
                        primary
                        inverted
                        disabled={!afterValue || !beforeValue}
                        onClick={() => {
                            onSubmit({
                                date_after: removeTimezoneOfDate(afterValue).toJSON(),
                                date_before: removeTimezoneOfDate(beforeValue).toJSON()
                            });
                        }}
                        label={t('common.cta.save')}
                    />
                </Button.Group>
            }
        >
            <div className={css['date-modal-content']}>
                {t('sauron.emails.email-logs.date-filter.time-range')}
                <div className={css['choose-range-buttons']}>
                    {presets.map(preset => {
                        return (
                            <Button
                                key={preset.key}
                                onClick={() => {
                                    setActiveKey(preset.key);
                                    setAfterValue(preset.date_after);
                                    setBeforeValue(preset.date_before);
                                }}
                                primary={preset.key === activeKey}
                                inverted={preset.key === activeKey}
                            >
                                {preset.label}
                            </Button>
                        );
                    })}
                </div>
                <DateTimeInput
                    dateLabel={t('sauron.emails.email-logs.date-filter.start-date')}
                    timeLabel={t('sauron.emails.email-logs.date-filter.time')}
                    onChange={newValue => setAfterValue(new Date(newValue))}
                    value={afterValue}
                />
                <DateTimeInput
                    dateLabel={t('sauron.emails.email-logs.date-filter.end-date')}
                    timeLabel={t('sauron.emails.email-logs.date-filter.time')}
                    onChange={newValue => setBeforeValue(new Date(newValue))}
                    value={beforeValue}
                />
            </div>
        </Modal>
    );
};
